import { Alert, Autocomplete, Box, Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { User } from "../api/user";
import { useGlobalState } from "../components/globalState";
import { useAuth } from "../context/AuthContext";

export const ImpersonateUserForm: React.FC<{
	onClose: () => void;
}> = ({ onClose }) => {
	const [username, setUsername] = useState<string>("");
	const [error, setError] = useState<string | null>(null);
	const [users, setUsers] = useState<User[]>([]);
	const { impersonate } = useAuth();
	const { currentUser } = useGlobalState();

	useEffect(() => {
		fetch("/api/v2/allusers/allusers/", {
			headers: {
				Authorization: `Bearer ${localStorage.getItem("access_token")}`,
			},
		})
			.then((res) => res.json())
			.then((data) => {
				if (Array.isArray(data)) {
					const filteredUsers = data.filter(
						(user) => user.username !== currentUser?.username
					);
					setUsers(filteredUsers);
				} else {
					console.error("Expected array of users, got:", data);
					setUsers([]);
				}
			})
			.catch((error) => {
				console.error("Failed to fetch users:", error);
				setUsers([]);
			});
	}, [currentUser?.username]);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setError(null);
		try {
			await impersonate(username);
			onClose();
			window.location.reload();
		} catch (err) {
			setError(err instanceof Error ? err.message : "Failed to impersonate user");
		}
	};

	return (
		<Box sx={{ p: 2 }} data-component="impersonate-form-container">
			{error && (
				<Alert
					severity="error"
					sx={{ mb: 2 }}
					data-component="impersonate-error"
				>
					{error}
				</Alert>
			)}

			<Box
				component="form"
				id="user-search-form"
				role="search"
				onSubmit={handleSubmit}
				noValidate
				data-component="impersonate-form"
			>
				<Autocomplete
					freeSolo
					fullWidth
					options={users}
					getOptionLabel={(option) =>
						typeof option === "string" ? option : option.username
					}
					onInputChange={(_, value) => setUsername(value)}
					data-component="impersonate-user-select"
					renderInput={(params) => (
						<TextField
							{...params}
							label="Select user"
							required
							fullWidth
							margin="normal"
							autoFocus
							data-component="impersonate-username-input"
						/>
					)}
				/>

				<Button
					type="submit"
					variant="contained"
					fullWidth
					size="large"
					sx={{ mt: 2 }}
					data-component="impersonate-submit"
				>
					Impersonate
				</Button>
			</Box>
		</Box>
	);
};
